import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '~/components/Tooltip';
import type { CommunityRole } from '~/interfaces/community/role';

import { Badge } from './Badge';
import { ROLE_BADGES } from './roleBadges';

const ROLE_BADGE_CLASS = 'bg-gray-100 text-gray-700';

type RoleBadgeProps = {
  communityRole: CommunityRole;
  interactive?: boolean;
};

export const RoleBadge: FC<RoleBadgeProps> = ({ communityRole, interactive = true }) => {
  const { t } = useTranslation();
  const { shortKey, labelKey } = ROLE_BADGES[communityRole];
  const shortLabel = t(shortKey);
  const fullLabel = t(labelKey);

  const badge = <Badge label={shortLabel} className={`uppercase tracking-wide ${ROLE_BADGE_CLASS}`} />;

  return !interactive ? (
    <span title={fullLabel} className="inline-flex items-center leading-none">
      {badge}
    </span>
  ) : (
    <Tooltip content={fullLabel} placement="bottom" className="group inline-flex items-center" interactive arrow>
      <button
        type="button"
        aria-label={fullLabel}
        className="inline-flex items-center p-0 m-0 border-0 bg-transparent leading-none cursor-default"
      >
        {badge}
      </button>
    </Tooltip>
  );
};
